import React, { useEffect } from 'react';
import { I18nProvider, useI18n } from './i18n/I18nProvider.jsx';
import { captureTrackingParams } from './utils/tracking';
import Header from './sections/Header';
import Hero from './sections/Hero';
import Why from './sections/Why';
import How from './sections/How';
import AI from './sections/AI';
import Pricing from './sections/Pricing';
import FAQ from './sections/FAQ';
import CTA from './sections/CTA';
import Footer from './sections/Footer';
import './App.css';

function AppContent() {
  const { lang } = useI18n();

  useEffect(() => {
    captureTrackingParams(lang);
  }, [lang]);

  return (
    <>
      <Header />
      <Hero />
      <Why />
      <How />
      <AI />
      <Pricing />
      <FAQ />
      <CTA />
      <Footer />
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <AppContent />
    </I18nProvider>
  );
}

export default App;